import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/styles/docket.css";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Reveal from "@/components/Reveal";

import Home from "@/pages/Home";
import Platform from "@/pages/Platform";
import HowItWorks from "@/pages/HowItWorks";
import Security from "@/pages/Security";
import Industries from "@/pages/Industries";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Insights from "@/pages/Insights";
import TwoBottlenecks from "@/pages/insights/TwoBottlenecks";
import TrainedVsGeneric from "@/pages/insights/TrainedVsGeneric";
import ReviewIsAFeature from "@/pages/insights/ReviewIsAFeature";
import AuditTrailByProduct from "@/pages/insights/AuditTrailByProduct";
import IdpPilotPlaybook from "@/pages/insights/IdpPilotPlaybook";

export default function App() {
  return (
    <BrowserRouter>
      <Header />
      <Reveal />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/platform" element={<Platform />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/security" element={<Security />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/two-bottlenecks" element={<TwoBottlenecks />} />
          <Route path="/insights/trained-vs-generic-idp" element={<TrainedVsGeneric />} />
          <Route path="/insights/review-is-a-feature" element={<ReviewIsAFeature />} />
          <Route path="/insights/audit-trail-by-product" element={<AuditTrailByProduct />} />
          <Route path="/insights/idp-pilot-playbook" element={<IdpPilotPlaybook />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}
